// Renk semasi: panel ayari + cihaz tercihi -> mod; koyu modda zemin/metin turevleri, marka renkleri sabit
const DARK_OVERRIDES = Object.freeze({
    backgroundColorFirst: "#111827", backgroundColorSecond: "#0f172a", textColor: "#e5e7eb", formColor: "#1f2937", formColorText: "#e5e7eb",
    representativeBubbleColor: "#1f2937", representativeTextColor: "#f3f4f6",
});
const SURFACES = Object.freeze({
    light: Object.freeze({ "sps-surface": "#ffffff", "sps-surface-raised": "#ffffff", "sps-border": "rgba(15, 23, 42, 0.08)", "sps-muted": "rgba(15, 23, 42, 0.6)", "sps-shadow": "0 4px 18px rgba(30, 30, 80, 0.10)", "chat-input-ph": "#a1a8a8", "color-bt": "#E4E8ED" }),
    dark: Object.freeze({ "sps-surface": "#1f2937", "sps-surface-raised": "#273449", "sps-border": "rgba(255, 255, 255, 0.08)", "sps-muted": "rgba(229, 231, 235, 0.65)", "sps-shadow": "0 4px 18px rgba(0, 0, 0, 0.45)", "chat-input-ph": "#9ca3af", "color-bt": "#374151" }),
});
function resolveColorScheme(scheme, prefersDark) {
    if (scheme === "dark") return "dark";
    if (scheme === "auto") return prefersDark ? "dark" : "light";
    return "light";
}
// WCAG bagil parlaklik; parse edilemeyen renk beyaz sayilir (guvenli varsayilan: koyulastir)
function relativeLuminance(hex) {
    if (typeof hex !== "string") return 1;
    let h = hex.trim().replace("#", "");
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return 1;
    const channel = (v) => {
        const c = parseInt(v, 16) / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * channel(h.slice(0, 2)) + 0.7152 * channel(h.slice(2, 4)) + 0.0722 * channel(h.slice(4, 6));
}
function deriveDarkColors(colors) {
    const base = { ...(colors || {}), ...DARK_OVERRIDES };
    // Cok acik marka basligi koyu govde uzerinde beyaz kalirdi: kendisi de koyulastirilir
    if (relativeLuminance(base.headerColorFirst) > 0.8) {
        base.headerColorFirst = "#1f2937";
        base.headerColorSecond = "#111827";
        base.headerTextColor = "#f3f4f6";
    }
    return base;
}
function surfaceTokens(mode) { return { ...SURFACES[mode === "dark" ? "dark" : "light"] }; }
module.exports = { resolveColorScheme, deriveDarkColors, surfaceTokens, relativeLuminance, DARK_OVERRIDES };



// WEBPACK FOOTER //
// ./src/utils/theme/colorScheme.js